import style from "./BlockedPage.module.css";
import useApplicationSettings from "../../Store/ApplicationSettings";
import { useEffect } from "react";
const MaintenancePage = () => {
  const setShowMenubar = useApplicationSettings(
    (state) => state.setShowMenubar
  );
  useEffect(() => {
    // Скрываем меню при монтировании компонента
    setShowMenubar(false);

    // Восстанавливаем меню при размонтировании
    return () => {
      setShowMenubar(true);
    };
  }, []);
  return (
    <div className={style["maintenance-container"]}>
      <div className={style["maintenance-content"]}>
        <div className={style["maintenance-icon"]}>⚠️</div>
        <h1 className={style["maintenance-title"]}>
          Ваш аккаунт заблокирован!
        </h1>
      </div>
      <div className={style["maintenance-button"]}>
        <a
          href="https://t.me/dream_support"
          className={style["maintenance-button-button"]}
        >
          Связаться с поддержкой
        </a>
      </div>
    </div>
  );
};

export default MaintenancePage;
